import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SortBot } from '../../../app/helpers/sort';
import { SelectItem } from 'primeng/primeng';
import { GetInvoicesByDateRequest } from '../../../app/models/ss-api/requests/get.invoices.by.date.request';
import { InvoiceArray, Invoice } from '../../../app/models/domain/invoice';
import { Angular2Csv } from 'angular2-csv';
import { InvoiceDetailsDialog } from '../../../app/dialogs/invoice.details/invoice.details.dialog';
import { Router } from '@angular/router';
import { LicenseManager } from '../../managers/License.manager';

@Component({
    selector: 'invoice-report',
    templateUrl: './invoice.report.component.html',
    styleUrls: ['./invoice.report.component.css']
})
export class InvoiceReportComponent implements OnInit {

    // VARIABLES
    IsBusy = false;

    Invoices: InvoiceArray;

    DateSearchOptions: SelectItem[];
    SelectedDateSearchOption = 1;

    SelectedInvoices: Array<number> = [];

    SelectedDate: Date = new Date();

    InvoiceFilterInput = '';

    resultRows = 25;
    firstResult = 0;
    lastResult = 24;

    constructor(private dialogService: DialogService,
        private api: ssApiService,
        private gb: GlobalService,
        private router: Router) { }

    ngOnInit() {

        this.gb.SetPageTitle('Invoice Report');

        this.DateSearchOptions = [
            { label: 'Creation Date', value: 0 },
            { label: 'Paid Date', value: 1 }
        ];

        this.LoadInvoices();
    }

    SortBy(sortVar1: string, sortVar2: string = '') {
        this.Invoices = SortBot.SortAuto(this.Invoices, sortVar1, sortVar2);
    }

    LoadInvoices() {
        this.IsBusy = true;
        let request: GetInvoicesByDateRequest = {
            Date: this.SelectedDate,
            DateType: this.SelectedDateSearchOption
        };

        let disposable = this.api.GetInvoicesByDate(request).subscribe(response => {
            this.IsBusy = false;

            this.Invoices = response.Data;

            disposable.unsubscribe();
        });
    }

    ExportToCSV() {
        let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: ['Invoice Number', 'Date Created', 'Date Paid', 'License Key', 'Transaction ID', 'Name', 'Email', 'Company', 'Status', 'Total', 'Paid', 'Refund', 'Credit', 'Due']
        };

        let ExportData = [];

        this.Invoices.forEach(function (item) {
            let transactionID = '';
            if (item.PaymentTransactions[0]) {
                transactionID = item.PaymentTransactions[0].GatewayTransactionID;
            }
            ExportData.push({
                InvoiceNumber: item.InvoiceNumber,
                DateCreated: item.DateTimeCreated,
                DatePaid: item.DateTimePaid,
                LicenseKey: item.LicenseKey,
                TransactionID: transactionID,
                Name: item.FirstName + ' ' + item.LastName,
                Email: item.Email,
                Company: item.Company,
                Status: item.Status,
                Total: item.Total,
                Paid: item.TotalPaid,
                Refund: item.TotalRefunded,
                Credit: item.Credit,
                Due: item.TotalDue
            });
        });

        new Angular2Csv(ExportData, 'InvoiceReport', options);
    }


    OnInvoiceClick(invoice: Invoice) {
        let disposable = this.dialogService.addDialog(InvoiceDetailsDialog, {
            title: 'Add New', subTitle : '',
            message: 'Confirm message',
            invoiceItem: invoice,
            memberName: ''
        }, { height: 650, width: 1200 }).subscribe( response => {
            disposable.unsubscribe();
        }, error => {
            disposable.unsubscribe();
        });
    }

    OnMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    OnLicenseClick(licenseKey: string) {
        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(licenseKey, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.LoadInvoices();
        });
    }

    InvoicesTotal() {
        let total = 0;
        this.Invoices.forEach(function (invoice) {
            total += invoice.Total;
        });

        return total;
    }

    InvoicesTotalPaid() {
        let totalPaid = 0;
        this.Invoices.forEach(function (invoice) {
            totalPaid += invoice.TotalPaid;
        });

        return totalPaid;
    }

    SelectInvoice(id: number) {
        let index = this.SelectedInvoices.indexOf(id);

        if (index >= 0) {
            this.SelectedInvoices.splice(index, 1);
        } else {
            this.SelectedInvoices.push(id);
        }
    }

    IsInvoiceSelected(id) {
        if (this.SelectedInvoices.indexOf(id) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    paginateInvoices(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

}
